module.exports = __webpack_public_path__ + "img/pticero.32dbfa64.jpg";